import React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import { EEstadoSolicitudConsumo } from "api/types/originacion/businessTypes";

const buildLabel = (background: string, foreground: string) =>
  styled(Chip)({
    backgroundColor: background,
    color: foreground,
    borderRadius: 4,
    padding: 4,
    height: "auto",
    "& .MuiChip-label": { fontWeight: "bold" },
  });

const YellowLabel = buildLabel("#fff7cc", "#ee9d00");
const RedLabel = buildLabel("#ffe0e0", "#dd1111");
const BlueLabel = buildLabel("#c7f2fa", "#009bba");
const GreenLabel = buildLabel("#d2f6e2", "#069661");
const OrangeLabel = buildLabel("#ffeece", "#f17f00");

const EstadoSolicitudConsumoLabel: React.FC<{
  estadoSolicitud: EEstadoSolicitudConsumo;
}> = ({ estadoSolicitud }) => {
  switch (estadoSolicitud) {
    case EEstadoSolicitudConsumo.Rechazada:
      return <RedLabel label="Rechazada" />;
    case EEstadoSolicitudConsumo.En_Analisis:
      return <YellowLabel label="En Análisis" />;
    case EEstadoSolicitudConsumo.Desistida:
      return <RedLabel label="Desistida" />;
    case EEstadoSolicitudConsumo.Aprobada:
      return <GreenLabel label="Aprobada" />;

    case EEstadoSolicitudConsumo.Incompleta:
      return <BlueLabel label="Incompleta" />;
    case EEstadoSolicitudConsumo.Liquidada:
      return <OrangeLabel label="Liquidada" />;
    default:
      return <YellowLabel label="En Análisis" />;
  }
};

export default EstadoSolicitudConsumoLabel;
